/**
 * Backing storage for {@link useWorkspaceTabState}: one bag of keyed values
 * per workspace tab, in-memory only. Kept apart from the hook so the tab
 * store can import `dropTabState` without a module cycle.
 */

/** State slot used before the tab store adopts a first tab. */
const NO_TAB = ''

const bags = new Map<string, Map<string, unknown>>()

export function readTabState<T>(
  tabId: string | null,
  key: string,
  initial: T,
): T {
  const bag = bags.get(tabId ?? NO_TAB)
  if (!bag?.has(key)) return initial
  return bag.get(key) as T
}

export function writeTabState(
  tabId: string | null,
  key: string,
  value: unknown,
): void {
  const id = tabId ?? NO_TAB
  const bag = bags.get(id) ?? new Map<string, unknown>()
  bag.set(key, value)
  bags.set(id, bag)
}

/** A closed workspace tab's UI state dies with it. */
export function dropTabState(tabId: string): void {
  bags.delete(tabId)
}
